import { c as _c } from "react/compiler-runtime";
import { ItemImage } from '@sbt-web/network/types';
import cn from 'classnames';
import CarouselPicture from './CarouselPicture';
import styles from './index.module.scss';
type Props = {
  fullScreen?: boolean;
  index: number;
  image: ItemImage;
  reduceDataUse?: boolean;
  shouldSkipLazyLoading: boolean;
  alt: string;
  isDesktop: boolean;
  switchFullscreen?: () => void;
};
const CarouselCell = t0 => {
  const $ = _c(20);
  const {
    image,
    index,
    isDesktop,
    fullScreen,
    reduceDataUse,
    alt,
    shouldSkipLazyLoading,
    switchFullscreen
  } = t0;
  const isFirstImage = index === 0;
  const t1 = `gallery-cell-${index}`;
  let t2;
  if ($[0] !== index) {
    t2 = index.toString();
    $[0] = index;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== fullScreen || $[3] !== isDesktop) {
    t3 = cn(styles["carousel-cell"], {
      "flickity-viewport": isDesktop,
      [styles["full-screen-figure"]]: fullScreen
    });
    $[2] = fullScreen;
    $[3] = isDesktop;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== alt || $[6] !== fullScreen || $[7] !== image || $[8] !== isFirstImage || $[9] !== reduceDataUse || $[10] !== shouldSkipLazyLoading || $[11] !== switchFullscreen) {
    t4 = fullScreen ? <CarouselPicture image={image} fullScreen={fullScreen} isFirstImage={isFirstImage} reduceDataUse={reduceDataUse} shouldSkipLazyLoading={shouldSkipLazyLoading} alt={alt} /> : <button onClick={switchFullscreen}><CarouselPicture image={image} fullScreen={fullScreen} isFirstImage={isFirstImage} reduceDataUse={reduceDataUse} shouldSkipLazyLoading={shouldSkipLazyLoading} alt={alt} /></button>;
    $[5] = alt;
    $[6] = fullScreen;
    $[7] = image;
    $[8] = isFirstImage;
    $[9] = reduceDataUse;
    $[10] = shouldSkipLazyLoading;
    $[11] = switchFullscreen;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t3 || $[14] !== t4) {
    t5 = <figure className={t3}>{t4}</figure>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t5) {
    t6 = <li id={t1} data-index={t2}>{t5}</li>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
};
export default CarouselCell;